"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Disclosures = function Disclosures(_ref) {
  var constants = _ref.constants,
    disclosureContent = _ref.disclosureContent,
    productType = _ref.productType;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures col-md-12"
  }, ['IF', 'PRP'].includes(productType) && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.ALL_PROMOTIONAL_PLANS
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PAYMENT_DETAILS_PROMOTIONAL_NO_INTEREST
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.NO_INTEREST_PLAN
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PAYMENT_DETAILS_PROMOTIONAL_PLANS
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.PROMOTIONAL_RATE_PLAN
    }
  }))), productType === 'IL' && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.FIXED_RATE_PLAN
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.FIXED_RATE_MONTHLY
    }
  }))), ['LCFRP', 'LCTNI'].includes(productType) && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__text",
    dangerouslySetInnerHTML: {
      __html: disclosureContent.LC_PLANS
    }
  }))));
};
Disclosures.propTypes = {
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.object,
  productType: _propTypes.default.string
};
Disclosures.defaultProps = {
  organization: 'Lending Club Patient Solutions'
};
var _default = Disclosures;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');